import logo from '../static/hs_logo01.jpg';

/**
 * The product's identity: its name and its logo. Screens import these rather than the image file or
 * the literal name, so a rebrand swaps the file imported above and the strings below. Colours live in
 * `tokens.ts`; the browser-tab and install icons live in `public/` (see AGENTS.md).
 */
export const brand = {
  appName: 'Health System',
  logoSrc: logo,
  logoAlt: 'Health System logo',
  copyrightUrl: 'http://healthinjector.com/'
} as const;
